
import wikiDown from '~/components/common/wikiDown.vue'
export default {
  components: {
    'wiki-down': wikiDown
  },
  data() {
    return {
      imgurl: `https://resources1.interface003.com/web20/img/company/down/download-${!'zh-cn,zh'.includes(this.$store.state.LanguageCode) ? 'en' : this.$store.state.LanguageCode}.png`,
      defaultImg: 'https://resources1.interface003.com/web20/img/home/down2/en.png?v=3',
      iconArr: {
        'zh-cn': [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/WikiFX-111931481518210'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/waihuitianyan1'
          },
          {
            type: 'INS',
            icon: 'icon-instagram-fill',
            url: 'https://www.instagram.com/FxeyeCHN/'
          }
        ],
        en: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/WikiFX.US'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/WikiFX_Eng'
          },
          {
            type: 'Linkedin',
            icon: 'icon-linkedin',
            url: 'https://www.linkedin.com/showcase/wikifx-eng'
          }
        ],
        vi: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/VietnamWikiFX'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/WikiFX_Vietnam'
          },
          {
            type: 'Linkedin',
            icon: 'icon-linkedin',
            url: 'https://www.linkedin.com/company/vietnamwikifx/'
          }
        ],
        th: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/Wikifx.th'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/WikiFX_TH'
          },
          {
            type: 'Linkedin',
            icon: 'icon-linkedin',
            url: 'https://www.linkedin.com/company/wikifx-th/'
          }
        ],
        zh: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/wikifx.tw'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/wikifx_tw'
          },
          {
            type: 'INS',
            icon: 'icon-instagram-fill',
            url: 'https://www.instagram.com/accounts/login/?next=/wikifx.tw/'
          }
        ],
        es: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/Wikifx.es'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/wikifx2022'
          },
          {
            type: 'INS',
            icon: 'icon-instagram-fill',
            url: 'https://instagram.com/wikifx.es?igshid=YmMyMTA2M2Y='
          }
        ],
        ja: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/wikifx.jp'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/WikiFXJP'
          },
          {
            type: 'Linkedin',
            icon: 'icon-linkedin',
            url: 'https://www.linkedin.com/in/wikifx-japan-b58b1723a/'
          }
        ],
        ru: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/wikifx.russian'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/WikiFX5'
          },
          {
            type: 'Linkedin',
            icon: 'icon-linkedin',
            url: 'https://www.linkedin.com/company/14534463/admin/'
          }
        ],
        fil: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/wikifx.pilipinas'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/BaronReynan'
          },
          {
            type: 'Linkedin',
            icon: 'icon-linkedin',
            url: 'https://www.linkedin.com/in/reynan-baron-281632194/'
          }
        ],
        id: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/wikifx.id'
          },
          {
            type: 'Twitter',
            icon: 'icon-Frame29',
            url: 'https://twitter.com/WikifxId'
          },
          {
            type: 'Linkedin',
            icon: 'icon-linkedin',
            url: 'https://www.linkedin.com/in/wikifx-indonesia-08bb1923a/'
          }
        ],
        hi: [],
        ar: [
          {
            type: 'Facebook',
            icon: 'icon-facebook2',
            url: 'https://www.facebook.com/wikifx.arab/'
          }
        ]
      }
    }
  },
  computed: {
    CurLanForImg() {
      const code = this.$store.state.LanguageCode
      if (code == 'zh-tw' || code == 'zh-hk' || code == 'zh') {
        return 'zh'
      } else {
        return code
      }
    },
    isWiki() {
      // 判断是否为国际
      if (this.$store.state.myCountry.toLowerCase() == 'cn') {
        return false
      } else {
        return true
      }
    }
  }
}
